export const isValidDate = (dateStr: any) => {
  return (
    !isNaN(+new Date(dateStr)) &&
    Date.parse(dateStr) / 1000 > 0 &&
    Date.parse(dateStr) / 1000 < 4102358400
  )
}
